@if (totalPages()) {
    <div class="pagination w-full">
        <div class="mx-auto flex w-max flex-row items-center gap-4">
            @if (currentPage() > 2 && !viewport.isMobile()) {
                <a
                    class="pagination-arrow"
                    [queryParams]="{ page: 1 }"
                    hyundaiRouterLink="."
                    queryParamsHandling="merge"
                >
                    <i class="icon-pagination-chevron-left-double"></i>
                </a>
            }

            @if (currentPage() > 1) {
                <a
                    class="pagination-arrow"
                    [queryParams]="{ page: currentPage() - 1 }"
                    hyundaiRouterLink="."
                    queryParamsHandling="merge"
                >
                    <i class="icon-pagination-chevron-left"></i>
                </a>
            }

            <div class="mx-12 flex gap-24 md:gap-32">
                @for (page of pagesRendered(); track $index) {
                    @if (page === '...') {
                        <span class="leading-19 text-16 font-medium text-grey-400">...</span>
                    } @else {
                        <a
                            class="leading-19 text-16 font-medium"
                            [ngClass]="[page === currentPage() ? 'text-accent' : 'text-grey-400']"
                            [queryParams]="{ page }"
                            hyundaiRouterLink="."
                            queryParamsHandling="merge"
                        >
                            {{ page }}
                        </a>
                    }
                }
            </div>

            @if (currentPage() < totalPages().length) {
                <a
                    class="pagination-arrow"
                    [queryParams]="{ page: currentPage() + 1 }"
                    hyundaiRouterLink="."
                    queryParamsHandling="merge"
                >
                    <i class="icon-pagination-chevron-right"></i>
                </a>
            }

            @if (currentPage() < totalPages().length - 1 && !viewport.isMobile()) {
                <a
                    class="pagination-arrow"
                    [queryParams]="{ page: totalPages().length }"
                    hyundaiRouterLink="."
                    queryParamsHandling="merge"
                >
                    <i class="icon-pagination-chevron-right-double"></i>
                </a>
            }
        </div>
    </div>
}
